<template>
    <div>
        
        <div class="table-box">
            <h6 class="text-sm mb-2 text-blue-700">استعلام کد شرکت</h6>
            <v-data-table
            dense
            :headers="table.headers"
            :items="table.items"
            :loading="loading"
            >
                <template #item.created_at="{ item }">
                    {{ getPersianDate(item.created_at) }}
                </template>
                <template #item.companyRelatedPeople="{ item }">
                    <button :disabled="!item?.companyRelatedPeople" @click="handelUserList(item.companyRelatedPeople)" class="bg-blue-600 disabled:opacity-30 text-white px-3 py-1 rounded-sm">مشاهده</button>
                </template>
                <template #item.message="{ item }">
                    <v-tooltip v-if="item.message" bottom max-width="250">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" class="text-[10px] max-w-[100px] overflow-hidden block text-ellipsis whitespace-nowrap">{{ item.message }}</span>
                        </template>
                        <span class="text-[10px]">{{ item.message }}</span>
                    </v-tooltip>
                </template>
                <!-- <template #item.status="{ item }">
                    <span :class="item.status == 1 ? 'text-green-500' : 'text-red-500'">
                        {{ item.status == 1 ? 'تایید شده' : 'رد شده' }}
                    </span>
                </template> -->
            </v-data-table>
        </div>
        <div class="mt-5 flex space-x-3 space-x-reverse">
            <v-btn color="success" @click="setAuthResult">
                <span class="text-xs">ثبت استعلام جدید</span>
            </v-btn>
            <v-btn :color="verify ? 'error' : 'info'" @click="changeStatusAuth">
                <span class="text-xs">{{ verify ? 'رد' : 'تایید' }} احراز هویت</span>
            </v-btn>
        </div>
        <VDialog v-model="userList.boxShow" max-width="500">
            <div class="bg-white rounded-lg p-5 shadow">
                <VDataTable v-if="userList.boxShow" :headers="userList.headers" :items="userList.data" />
            </div>
        </VDialog>
    </div>
</template>

<script>
import axiosApi from "@/plugins/axios";

export default {
    props: ['userId', 'userType', 'verify'],
    data() {
        return {
            loading: false,
            userList: {
                boxShow: false,
                data: [],
                headers: [
                    { text: 'نام و نام خانوادگی', value: 'lastName'},
                    { text: 'کدملی', value: 'nationalCode'},
                    { text: 'پست', value: 'officePosition'},
                ]
            },
            
            userData: {
                type: this.userType,
                id: this.userId,
            },
            table: {
                headers: [
                    { text: 'شناسه', value: 'id'},
                    { text: 'نام شرکت', value: 'companyTitle'},
                    { text: 'شناسه ثبت', value: 'companyRegistrationId'},
                    { text: 'کد پستی', value: 'postalCode'},
                    { text: 'شناسه ملی شرکت', value: 'nationalId'},
                    { text: 'تاریخ تاسیس شرکت', value: 'establishmentDate'},
                    { text: 'وضعیت استعلام', value: 'message'},
                    { text: 'تاریخ ایجاد', value: 'created_at'},
                    { text: 'وضعیت', value: 'status'},
                    { text: 'افراد مرتبط با شرکت', value: 'companyRelatedPeople'},
                ],
                items: [],
            }
        }
    },
    watch: {
        'userList.boxShow': function() {
            this.userList.boxShow === false ? this.userList.data = [] : ''
        }
    },
    computed: {
        endPoint(){
            switch (this.userData.type) {
                case 'FACTORY':
                    return  'factory'                  
                case 'COMPANY':
                    return  'company'                  
            }
            return ''
        },
    },
    methods: {
        handelUserList(list){
            list = JSON.parse(list)
            this.userList.boxShow = true
            this.userList.data = [...list]
        },
        getAuthResultListHistory(){
            this.loading = true
            axiosApi().post('v2/admin/inquiry/nationalIdCompanyResult', this.userData)
            .then((result) => {
                this.table.items = result.data.data.result || []
                console.log(JSON.parse(this.table.items[0].companyRelatedPeople));
            }).catch((err) => {
                console.log(err);
            }).finally(() => this.loading = false)
        },
        setAuthResult(){
            this.loading = true
            axiosApi().post('v2/admin/inquiry/nationalIdCompany', this.userData)
            .then(() => {
                this.$toast.open({
                    message: 'استعلام گرفته شد',
                    type: 'success'
                })
                this.getAuthResultListHistory()
            }).catch((err) => {
                console.log(err);
            }).finally(() => this.loading = false)
        },
        changeStatusAuth(){
            this.loading = true
            axiosApi().post(`v2/admin/${this.endPoint}/verify`, {
                [`${this.endPoint}_id`]: this.userData.id
            })
            .then(() => {
                this.$toast.open({
                    message: 'احراز هویت تایید شد',
                    type: 'success'
                })
                this.getAuthResultListHistory()
                this.$emit('updateVerify')
            }).catch((err) => {
                console.log(err);
            }).finally(() => this.loading = false)

        }
    },
    mounted(){
        this.getAuthResultListHistory()
    }    
}
</script>

<style>
.table-box .v-data-table > .v-data-table__wrapper > table > tbody > tr > td *,
.table-box .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
    font-size: 11px !important;
}
.table-box .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th{
    white-space: nowrap !important;
}
</style>